<script setup lang="ts">
import { usePlaceMenuStore } from "@/modules/place-module";
import { computed } from "vue";
import PlaceProductCard from "../PlaceMenu/PlaceProductCard.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const placeMenuStore = usePlaceMenuStore();
const product = computed(() => placeMenuStore.product);
</script>

<template>
  <section class="other-products">
    <h4>{{ t("place.product.otherProducts") }}</h4>

    <div v-if="product" class="other-products__list">
      <PlaceProductCard
        v-for="(_product, index) in product.other_products"
        :key="index"
        :product="_product"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.other-products {
  padding: calc($base-space * 6) ($base-space * 8);
  border-top: 1px solid var(--color-semantic-border-normal-soft);

  @media (max-width: 1023px) {
    padding: calc($base-space * 6);
  }

  @media (max-width: 767px) {
    padding: calc($base-space * 5) ($base-space * 4);
  }

  > h4 {
    @include body-bold-l();
    color: var(--color-semantic-content-normal-primary);
  }

  &__list {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: calc($base-space * 4);
    margin: calc($base-space * 4) calc($base-space * -8) 0 0;
    padding: 0 calc($base-space * 8) 0 0;
    overflow: auto;
    @include hideScroll();

    @media (max-width: 1023px) {
      margin: calc($base-space * 3) calc($base-space * -6) 0 0;
      padding: 0 calc($base-space * 6) 0 0;
    }

    @media (max-width: 767px) {
      margin: calc($base-space * 3) calc($base-space * -4) 0 0;
      padding: 0 calc($base-space * 4) 0 0;
    }

    > .product-card {
      width: 200px;

      @media (max-width: 1023px) {
        width: 170px;
      }
    }
  }
}
</style>
